import { Suspense, useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../redux/store";
import { AppBar, Dialog, IconButton, Toolbar, Typography } from "@mui/material";
import PageLoader from "../loader/LoaderText";
import ProjectMasterPage from "./Projects";
import DocumentMasterPage from "./Documents";
import EventRegister from "./Events";
import UsersMasterPage from "./Users";
import AdminTableViewDialog from "./AdminTable";
import WorkflowMasterDialogComponent from "./Workflow";
import UserRegisterPage from "./UserRegister";
import { closeDialog } from "../../redux/reducer/dialogSlice";
import { Close } from "@mui/icons-material";
import ResponsiveEllipsisTitle from "../common/ResponsiveEllipsisTitle";
import RegisterDialogPage from "./guest";
import TriPartyMOUPage from "./tri-party-mou";

const CommonDialogComponent = () => {   
    const { isOpen, isFullScreen, size, title } = useSelector((state: RootState) => state.dialog);
    const dispatch = useDispatch();

    const handleClose = useCallback(() => {
        dispatch(closeDialog());
    }, [dispatch]);
    return (
        <Dialog open={isOpen} fullScreen={isFullScreen} fullWidth={true} maxWidth={size as 'xs' | 'sm' | 'md' | 'lg' | 'xl' ?? 'md'}>
            {isFullScreen && <AppBar elevation={7} sx={{ position: 'relative', height: '59px' }}>
                <Toolbar sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                    <Typography sx={{ flex: 1 }} variant="h5" fontWeight={"h4.fontWeight"} component="div"> <ResponsiveEllipsisTitle title={title || ''} /></Typography>
                    <IconButton edge="start" color="inherit" onClick={handleClose}> <Close /> </IconButton>
                </Toolbar>
            </AppBar>}
            <Suspense fallback={<PageLoader />}>
                <ProjectMasterPage />
                <DocumentMasterPage />
                <EventRegister />
                <UserRegisterPage />
                <UsersMasterPage />
                <AdminTableViewDialog />
                <WorkflowMasterDialogComponent />
                <RegisterDialogPage />
                <TriPartyMOUPage />
            </Suspense>
        </Dialog>
    )
}
export default CommonDialogComponent